// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/logo_TerriSTORY_region_nouvelle_aquitaine_small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/logo_TerriSTORY_region_occitanie.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/logo_TerriSTORY_region_aura_small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/logo_TerriSTORY_region_paysdelaloire.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/logo_TerriSTORY_region_bretagne.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/logo_TerriSTORY_region_corse.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-print {
    display: inline-flex;
}

.printable {
    visibility: hidden;
}

.logo-territorialsynthesis-print {
    width: 450px;
    height: 90px;
    z-index: 10;
}

.logo-territorialsynthesis-vert-nouvelle-aquitaine {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat
        center center;
    background-size: auto 60px;
    margin-left: 20px;
}

.logo-territorialsynthesis-vert-occitanie {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
    background-size: auto 60px;
    margin-left: 20px;
}

.logo-territorialsynthesis-vert-aura-ee {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
    background-size: auto 60px;
    margin-left: 20px;
}

.logo-territorialsynthesis-vert-paysdelaloire {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
    background-size: auto 60px;
    margin-left: 20px;
}

.logo-territorialsynthesis-vert-bretagne {
    background: rgba(255, 255, 255, 1) url(${___CSS_LOADER_URL_REPLACEMENT_4___})
        no-repeat center center;
    background-size: auto 60px;
    margin-left: 20px;
}

.logo-territorialsynthesis-vert-corse {
    background: rgba(255, 255, 255, 1) url(${___CSS_LOADER_URL_REPLACEMENT_5___})
        no-repeat center center;
    background-size: auto 60px;
    margin-left: 20px;
}

.footer-block {
    float: left;
    margin-top: 10px;
}

.footer-block img {
    margin-left: 10px;
    margin-right: 10px;
    max-height: 60px;
}

.footer-block label {
    width: 100%;
    font-style: Italic;
    text-shadow: 2px 2px rgba(100, 100, 100, 0.2);
    margin-right: 5px;
}

.footer-block label.subtitle {
    text-shadow: none;
    font-size: 10px;
}

.export-date {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/style/territorialsynthesis.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;;qBAEiB;IACjB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI;uEAC8E;IAC9E,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI;uEAC+E;IAC/E,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI;uEACkF;IAClF,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI;+BAC2B;IAC3B,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI;+BAC2B;IAC3B,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".footer-print {\n    display: inline-flex;\n}\n\n.printable {\n    visibility: hidden;\n}\n\n.logo-territorialsynthesis-print {\n    width: 450px;\n    height: 90px;\n    z-index: 10;\n}\n\n.logo-territorialsynthesis-vert-nouvelle-aquitaine {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_nouvelle_aquitaine_small.png\") no-repeat\n        center center;\n    background-size: auto 60px;\n    margin-left: 20px;\n}\n\n.logo-territorialsynthesis-vert-occitanie {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_occitanie.png\") no-repeat center center;\n    background-size: auto 60px;\n    margin-left: 20px;\n}\n\n.logo-territorialsynthesis-vert-aura-ee {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_aura_small.png\") no-repeat center center;\n    background-size: auto 60px;\n    margin-left: 20px;\n}\n\n.logo-territorialsynthesis-vert-paysdelaloire {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_paysdelaloire.png\") no-repeat center center;\n    background-size: auto 60px;\n    margin-left: 20px;\n}\n\n.logo-territorialsynthesis-vert-bretagne {\n    background: rgba(255, 255, 255, 1) url(\"../img/logo_TerriSTORY_region_bretagne.png\")\n        no-repeat center center;\n    background-size: auto 60px;\n    margin-left: 20px;\n}\n\n.logo-territorialsynthesis-vert-corse {\n    background: rgba(255, 255, 255, 1) url(\"../img/logo_TerriSTORY_region_corse.png\")\n        no-repeat center center;\n    background-size: auto 60px;\n    margin-left: 20px;\n}\n\n.footer-block {\n    float: left;\n    margin-top: 10px;\n}\n\n.footer-block img {\n    margin-left: 10px;\n    margin-right: 10px;\n    max-height: 60px;\n}\n\n.footer-block label {\n    width: 100%;\n    font-style: Italic;\n    text-shadow: 2px 2px rgba(100, 100, 100, 0.2);\n    margin-right: 5px;\n}\n\n.footer-block label.subtitle {\n    text-shadow: none;\n    font-size: 10px;\n}\n\n.export-date {\n    font-size: 14px;\n    text-align: right;\n    margin-top: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
